import * as React from "react"

function Like({ height, width, stroke }) {
    return (
        <svg height={height ? height : 24} viewBox="0 0 21 21" width={width ? width : 24}>
            <g
                fill="none"
                fillRule="evenodd"
                stroke={stroke ? stroke : '#000'}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M13.602 16.741L10.5 15.5h-4v-7h2L11.3 3c.58 0 1.075.205 1.485.615.41.41.615.905.615 1.485l-.9 2.4 4.031 1.344a2 2 0 011.24 2.6l-1.553 4.142a2 2 0 01-2.616 1.155zM3.5 7.5h2a1 1 0 011 1v8a1 1 0 01-1 1h-2a1 1 0 01-1-1v-8a1 1 0 011-1z" />
            </g>
        </svg>
    )
}

export default Like
